var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 274,
    viewBox: "0 0 268 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.822 171.251L154.954 143.687L163.505 150.398L179.645 93.4734L189.16 131.583L203.011 126.19L193.857 147.402L151.822 171.251Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7428 188.946H11.0894",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7765 201.574H16.7393",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6597 189.311L13.2542 218.17",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.182 189.311L49.7764 218.17",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.442 147.341L155.242 167.302C126.172 162.131 110.076 134.354 124.01 119.082C133.38 108.861 118.124 93.5899 108.754 103.811C96.2614 117.519 92.1771 137.36 99.745 154.556C106.592 170.068 122.328 180.409 139.026 181.491C139.746 181.491 140.347 181.611 141.068 181.611L161.609 170.789L196.205 152.632L193.442 147.341Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.012 27.3052L99.177 39.8033L150.456 137.798L174.291 125.3L123.012 27.3052Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.636 120.526L146.332 135.367L149.788 141.971L178.092 127.13L174.636 120.526Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.493 15.6039L96.7666 22.8015L109.753 47.6197L123.48 40.4221L110.493 15.6039Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.397 90.2227C150.802 100.444 146.838 113.07 136.628 118.481C126.417 123.892 113.804 119.924 108.399 109.703C101.552 96.5959 106.957 86.8558 117.168 81.4446C127.378 76.0335 139.991 80.0016 145.397 90.2227Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.698 95.8753C136.981 100.204 135.299 105.495 130.975 107.66C126.65 109.944 121.365 108.261 119.202 103.932C116.319 98.4005 118.602 94.3121 122.926 92.1476C127.131 89.9832 132.416 91.5464 134.698 95.8753Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.609 211.553C161.849 206.263 160.768 200.851 158.125 195.801C150.197 180.529 131.337 174.758 116.202 182.694C104.67 188.706 97.2221 198.567 98.7837 211.553H161.609Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.646 207.342H81.8462V218.164H197.646V207.342Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.795 208.908C147.915 205.902 147.314 202.896 145.873 200.13C141.428 191.593 130.857 188.346 122.328 192.795C115.842 196.162 111.637 201.693 112.598 209.029",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.795 208.908C147.915 205.902 147.314 202.896 145.873 200.13C141.428 191.593 130.857 188.346 122.328 192.795C115.842 196.162 111.637 201.693 112.598 209.029",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.316 67.857L239.929 40.6809C239.929 40.6809 313.565 166.46 217.946 205.902C139.865 238.128 131.817 261.456 122.447 273L24.666 240.413C24.666 240.413 44.967 191.953 113.077 168.505C181.188 145.056 171.458 115.595 150.316 67.857Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.471 251.594L47.7305 231.994",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2566 236.204C79.2021 231.515 65.1476 226.825 51.093 222.135",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.832 241.736C106.228 240.533 102.624 239.331 99.0208 238.128",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M233.681 95.6343C235.242 95.1533 236.804 94.6723 238.366 94.1913",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M197.044 106.697C207.254 103.571 217.465 100.444 227.675 97.4379",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.377 112.949C222.266 110.904 231.035 108.98 239.925 106.936",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.766 116.437C201.009 115.716 204.253 114.994 207.496 114.273",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M186.954 104.413L194.162 84.5724L207.615 88.6609L224.673 58.9596",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.904 159.862L206.541 143.303L190 178.702L225.363 195.261L241.904 159.862Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M181.187 191.833L170.496 179.568L195.242 157.803L206.053 170.069L181.187 191.833Z",
    fill: "url(#paint1_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.159 203.254L182.63 193.514L199.808 178.483L208.336 188.223L191.159 203.254Z",
    fill: "url(#paint2_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.49 241.016L116.922 237.408L124.249 222.016L131.817 225.624L124.49 241.016Z",
    fill: "url(#paint3_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M115.36 236.685L107.792 233.077L113.558 220.932L121.126 224.54L115.36 236.685Z",
    fill: "url(#paint4_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.577 244.38L125.571 241.494L130.616 230.912L136.622 233.798L131.577 244.38Z",
    fill: "url(#paint5_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.802 7.73389L126.528 1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M121.607 15.7879L136.863 11.3387",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M201.603 139.044L197.039 144.215",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M147.789 159.486L149.471 162.132",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M207.492 151.549L210.496 154.676",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M212.42 168.263V173.193",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M215.064 159.487L219.269 157.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3759 187.746L1 164.538C1 164.538 18.7784 153.115 24.0639 149.267C29.3493 145.419 37.5178 163.576 37.5178 163.576L18.7784 177.044C18.6583 176.924 21.9016 184.139 16.3759 187.746Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6575 176.923L19.0178 171.272",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6133 173.197L21.4183 174.64",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0993 188.708L32.2305 188.587C32.2305 188.587 32.5908 167.424 32.2305 160.93C31.9902 154.437 51.5705 157.684 51.5705 157.684L52.2912 180.771C52.2912 180.771 60.0993 181.974 60.0993 188.708Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1522 174.519H53.8557C53.3752 151.191 51.8136 120.046 51.213 96.7182C50.9728 84.9339 50.6124 73.1496 50.4922 61.3653C50.252 51.505 50.1319 41.1636 54.9369 32.2653C61.5437 20 42.9244 9.17766 36.3176 21.3227C25.0259 42.2459 28.99 68.4599 29.4705 91.4273C30.0711 116.439 30.6717 149.387 31.1522 174.519Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2974 38.3983C54.3364 32.6264 47.2491 29.3797 42.0837 30.8226C35.9574 32.5061 33.5549 38.278 34.5159 44.0499C39.9215 76.1561 52.054 129.306 17.8186 151.672C17.6985 151.792 17.5784 151.792 17.4583 151.912C20.8217 158.286 24.4255 164.418 28.1493 170.671C28.2694 170.551 28.5097 170.431 28.6298 170.31C47.3692 158.165 62.7451 136.881 65.2677 115.116C68.1507 89.8644 59.5017 63.2896 55.2974 38.3983Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2952 180.771L47.7305 177.284",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0886 180.412L51.9335 177.165",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6326 139.886C37.0382 132.791 50.8524 108.141 31.9929 45.4913",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5562 166.82C38.241 163.814 48.6918 151.669 51.0943 148.663",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M100.104 5.45149C101.905 7.01472 103.227 9.17918 103.227 12.0651C100.824 12.4259 97.1005 10.8627 95.8993 9.90067C94.698 8.93869 93.3767 10.5019 93.8572 11.7044C94.3377 12.7866 91.0943 12.4259 90.4937 12.0651C90.2534 11.9449 90.0132 11.7044 89.7729 11.5841C89.8931 9.78042 90.9742 7.9767 93.3767 6.17298C93.737 5.81223 94.2175 5.45149 94.8182 4.9705C96.4999 4.9705 98.3018 5.211 100.104 5.45149Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3766 6.17358C91.2144 7.85705 90.1333 9.66077 89.893 11.3442L74.397 10.1418L76.5592 17.2364L92.8961 18.3186C96.0193 21.0843 99.3828 18.1984 99.3828 18.1984L101.065 18.6794C101.065 18.6794 102.746 16.5149 103.227 12.186C103.707 7.7368 98.1816 2.32564 93.3766 6.17358Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0021 13.8676C75.2393 4.00727 66.7105 -3.56836 33.5562 20.1205C41.124 28.1771 48.8119 36.1135 56.4999 44.0499C62.1457 41.1639 69.8337 37.4362 74.6387 35.392C82.8071 32.0251 80.765 23.247 78.0021 13.8676Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M118.002 39.8396C123.888 38.3966 127.252 35.9916 128.933 37.6751C130.615 39.3586 123.528 40.6813 125.57 42.004C127.612 43.3268 131.576 40.3206 132.657 42.7255C133.618 45.1305 126.651 46.4532 126.651 46.4532C126.651 46.4532 133.017 44.409 133.738 46.0925C134.459 47.776 127.011 50.7822 127.011 50.7822C127.011 50.7822 133.378 48.3772 134.459 50.4214C135.42 52.4656 128.693 54.0289 121.846 56.9148",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M118.002 39.8396C123.888 38.3966 127.252 35.9916 128.933 37.6751C130.615 39.3586 123.528 40.6813 125.57 42.004C127.612 43.3268 131.576 40.3206 132.657 42.7255C133.618 45.1305 126.651 46.4532 126.651 46.4532C126.651 46.4532 133.017 44.409 133.738 46.0925C134.459 47.776 127.011 50.7822 127.011 50.7822C127.011 50.7822 133.378 48.3772 134.459 50.4214C135.42 52.4656 128.693 54.0289 121.846 56.9148",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8601 15.7902C49.6526 31.1819 56.2595 48.9787 71.1549 56.915C87.1314 65.4526 105.03 61.8452 121.487 57.0353C120.166 51.2634 118.964 45.6117 117.883 39.8398C107.673 42.9663 96.381 46.4534 85.6899 43.808C77.7617 41.884 65.7493 32.9857 72.4763 20.1191",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8601 15.7902C49.6526 31.1819 56.2595 48.9787 71.1549 56.915C87.1314 65.4526 105.03 61.8452 121.487 57.0353C120.166 51.2634 118.964 45.6117 117.883 39.8398C107.673 42.9663 96.381 46.4534 85.6899 43.808C77.7617 41.884 65.7493 32.9857 72.4763 20.1191",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.677 42.1244L114.761 58.9592",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M116.44 52.5868L116.801 54.9923",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 177.417,
    y1: 93.4734,
    x2: 177.417,
    y2: 171.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 188.274,
    y1: 157.803,
    x2: 188.274,
    y2: 191.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 195.483,
    y1: 178.483,
    x2: 195.483,
    y2: 203.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 124.37,
    y1: 222.016,
    x2: 124.37,
    y2: 241.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 114.459,
    y1: 220.932,
    x2: 114.459,
    y2: 236.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 131.096,
    y1: 230.912,
    x2: 131.096,
    y2: 244.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.5cf7e60b704e89b7c9d769480fad6a47.svg";
export { ForwardRef as ReactComponent };